import { render, staticRenderFns } from "./index_v1.vue?vue&type=template&id=a6130afe&scoped=true"
import script from "./index_v1.vue?vue&type=script&lang=js"
export * from "./index_v1.vue?vue&type=script&lang=js"
import style0 from "./index_v1.vue?vue&type=style&index=0&id=a6130afe&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6130afe",
  null
  
)

export default component.exports